/**
 * @generated SignedSource<<66bab35d760ddfbc88479fa6174fd8d2>>
 * @relayHash d280e7754313d59bf41d046a9f0145e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cd4b2a607c8ef4af12a7c0ffc5512cb4f98128361abb598a7be8e3510838a802

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentStudioAgentCreatorType = "CUSTOMER" | "FORGE" | "GUIDED" | "OOTB" | "REMOTE_A2A" | "ROVO_CHAT" | "ROVO_DEV" | "%future added value";
export type AgentStudioAgentQueryInput = {
  creatorTypes?: ReadonlyArray<AgentStudioAgentCreatorType> | null;
  includeDraftAgents?: boolean | null;
  includeJiraCodingAgent?: boolean | null;
  includeRovoChatAgent?: boolean | null;
  name?: string | null;
  onlyEditableAgents?: boolean | null;
  onlyFavouriteAgents?: boolean | null;
  onlyMyAgents?: boolean | null;
  onlyPublishedEditableAgents?: boolean | null;
  onlyPublishedEditableAgentsWithForge?: boolean | null;
  onlyTemplateAgents?: boolean | null;
  onlyUnpublishedAgents?: boolean | null;
  onlyVerifiedAgents?: boolean | null;
};
export type DefaultAgentResultsQuery$variables = {
  cloudId: string;
  first: number;
  input?: AgentStudioAgentQueryInput | null;
  product?: string | null;
};
export type DefaultAgentResultsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DefaultAgentResults">;
};
export type DefaultAgentResultsQuery = {
  response: DefaultAgentResultsQuery$data;
  variables: DefaultAgentResultsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "product"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  },
  {
    "kind": "Variable",
    "name": "product",
    "variableName": "product"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "DefaultAgentResultsQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "FragmentSpread",
        "name": "DefaultAgentResults"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "DefaultAgentResultsQuery",
    "selections": [
      {
        "alias": "browseAgentResults",
        "args": (v4/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioAssistant",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isVerified"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "icon"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "externalConfigReference"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "identityAccountId"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "identityAccount",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isUser"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "picture"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "appType"
                          }
                        ],
                        "type": "AppUser"
                      },
                      (v5/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "creatorType"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "forgeCreator"
                  },
                  {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "authoringTeam",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "displayName"
                      },
                      (v5/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v6/*: any*/),
                      (v5/*: any*/)
                    ]
                  },
                  (v7/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "alias": "browseAgentResults",
        "args": (v4/*: any*/),
        "filters": [
          "cloudId",
          "product",
          "input"
        ],
        "handle": "connection",
        "key": "DefaultAgentResults_browseAgentResults",
        "kind": "LinkedHandle",
        "name": "agentStudio_getAgents"
      }
    ]
  },
  "params": {
    "id": "cd4b2a607c8ef4af12a7c0ffc5512cb4f98128361abb598a7be8e3510838a802",
    "metadata": {},
    "name": "DefaultAgentResultsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1ebafa7b6a14f48e8111dc5e47f7a9d3";

export default node;
